(function (module) {
  'use strict';
  module.directive('permissions', ['authService', function (authService) {
    return {
      restrict: 'A',
      scope: {
        permissions: '=',
      },
      link: function (scope, elem, attrs) {
        scope.$watch(authService.isLoggedIn, function () {
          if (authService.userHasPermission(scope.permissions)) {
            elem.show();
          } else {
            elem.hide();
          }
        });
      },
    };
  }, ]);

})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/directives/allowedPermissions.directive.js